import { use } from 'react'

import { AdvanceStepsContext } from '../TakeAdvanceSteps'

export function useAdvanceContentContext() {
  const context = use(AdvanceStepsContext)
  if (!context) {
    throw new Error(
      'AdvanceStepsContext must be used within a TakeAdvanceContent'
    )
  }
  return context
}
